import React from 'react';
import img from '../../assets/bubble-img.webp'

const Plan = () => {
    return (
        <>
            <div className="plan-section">
                <div className="container">
                    <h5 className="section-head d-none d-md-block plan-head-copy">Pick Your Perfect Plan</h5>
                    <h5 className="section-head d-md-none plan-margin">Pick Your Plan</h5>
                    <p className="plan-p d-none">Perfect Pools, Zero Hassle – Lock It In</p>
                    <div className="row pt10">
                        <div className="col-md-6">
                            <a href="javascript:void(0)" className="landing-slider-button rm_text_dec">
                                <div className="plan-card h-100">
                                    <p className="trail-p">Free Trial</p>
                                    <h4 className="price-day">10-Day</h4>
                                    <p className="price-p">Full access, no card required.</p>
                                </div>
                            </a>
                        </div>
                        <div className="col-md-6">
                            <a href="javascript:void(0)" className="show_paid_plans rm_text_dec position-relative">
                                <div className="plan-card h-100">
                                    <p className="trail-p">12 Month Plan</p>
                                    <h4 className="price-day">$22/month</h4>
                                    <div className="badge-plan">
                                        <span>(billed annually) - $264 total</span>
                                    </div>
                                </div>
                                <div className='postion-absolute bubble-main-div'>
                                    <div className='position-relative d-inline-block'>
                                        <img src={img} alt="" className='img-bubble img-fluid' />
                                        <div className='price-abso'>
                                            <p className='m-0'>WAS</p>
                                            <h3>$399</h3>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>

                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="filling-div">Mighty May Sale – Spots Filling Fast!</div>
                            {/* <div className="time-div">
                                <span className="text-time">Ends in X days!</span>
                                <span className="time-span">2:59:59</span>
                            </div> */}
                            <a href="javascript:void(0)" className="landing-slider-button rm_text_dec">
                                <div className="time-div time-div-pad flex-column padding-timer-new m-0">
                                    <p className='timer-p'>First 100 Free Trials Today Score a Free ‘Master Your Pool’ Guide ($59 Value)</p>
                                    <h4 className='timer-left'>Only <span>100</span> Left!</h4>
                                    <p className='timer-p m-0'>Win Big or Miss Out? No Freebie – Act fast!</p>
                                </div>
                            </a>
                            <div className="text-center">
                                <button className="btn btn-lock landing-slider-button">Lock It In</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Plan;
